export enum Theme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
  SUBTLE = 'SUBTLE',
}

export enum Padding {
  TIGHT = 'TIGHT',
  LOOSE = 'LOOSE',
}

export enum Width {
  MIN = 'MIN',
  MAX = 'MAX',
}

export enum Height {
  EXTRA_SMALL = 'EXTRA_SMALL',
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export interface ButtonGroupOption {
  text: string;
  value: string;
  icon?: string;
  tooltip?: string;
  isDisabled?: boolean;
  dataPendoId?: string;
}

export interface ButtonGroupProps {
  onChange: (value: string) => void;
  options: ButtonGroupOption[];
  selectedValue: string;
  padding?: Padding;
  theme?: Theme;
  dataTestId?: string;
  icon?: string;
  isDisabled?: boolean;
  width?: Width;
  height?: Height;
  testIdSource?: 'index' | 'text';
}
